<div class="event-info-card">
  <p class="event-info-card__title">INFORMAÇÕES DO EVENTO</p>
  <p class="event-info-card__item"><strong>NOME:</strong> {{ event.title }}</p>
  <p class="event-info-card__item"><strong>DATA:</strong> {{ event.start_date | date: "dd/MM/yyyy" }}</p>
  <p class="event-info-card__item">
    <strong>LOCAL:</strong> {{ event.address?.location_name ?? event.address?.city_name }}
  </p>
  <p class="event-info-card__item"><strong>STATUS:</strong> {{ event.status | eventStatus }}</p>
  <a class="event-info-card__link" [routerLink]="['/event', event.id]"> Ver página do evento </a>
</div>
